import ProductsAndServices from './products-and-services.vue';
import DiscoverContent from './discover-content.vue';
import DiscoveryToolIntegration from './discovery-tool-integration.vue';
import ProductsAndServicesLinks from './products-and-services-links.vue';
import Popover from '../components/popover.vue';
import AccordionItem from '../components/accordion-item.vue';
import IconCompass from '../components/icon/compass.vue';
export default {
  components: {
    DiscoverContent,
    DiscoveryToolIntegration,
    ProductsAndServices,
    ProductsAndServicesLinks,
    Popover,
    AccordionItem,
    IconCompass
  },
  props: {
    showDiscoveryTool: {
      type: Boolean,
      default: false
    },
    environment: {
      type: String,
      required: true
    }
  }
};